// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewPage span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    cursor: pointer;
    color: #ffffff;
    font-size: 0.87rem;
    padding-bottom: 0.1rem;
    width: 100%;
    height:100%;
    background-color: rgba(60, 60, 60, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    display: none;
  }

  .viewPage:hover span {
    display: flex;
  }

  .viewCategories span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    cursor: pointer;
    color: #ffffff;
    font-size: 0.87rem;
    padding-bottom: 0.1rem;
    width: 100%;
    height:100%;
    background-color: rgba(60, 60, 60, 0.5);
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    text-align: center;
    justify-content: left;
    border-radius: 5px;
    display: none;
  }

  .viewCategories:hover span {
    display: flex;
  }
 `, "",{"version":3,"sources":["webpack://./src/includes/pages/allCategories.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAET,gCAAgC;IAChC,UAAU;IACV,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,uCAAuC;IAGvC,aAAa;IAGb,mBAAmB;IAGnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IAGE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAET,gCAAgC;IAChC,UAAU;IACV,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,uCAAuC;IAGvC,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAGlB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IAGE,aAAa;EACf","sourcesContent":[".viewPage span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    z-index: 2;\n    cursor: pointer;\n    color: #ffffff;\n    font-size: 0.87rem;\n    padding-bottom: 0.1rem;\n    width: 100%;\n    height:100%;\n    background-color: rgba(60, 60, 60, 0.5);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    border-radius: 5px;\n    display: none;\n  }\n\n  .viewPage:hover span {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n\n  .viewCategories span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    z-index: 2;\n    cursor: pointer;\n    color: #ffffff;\n    font-size: 0.87rem;\n    padding-bottom: 0.1rem;\n    width: 100%;\n    height:100%;\n    background-color: rgba(60, 60, 60, 0.5);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    text-align: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: left;\n    border-radius: 5px;\n    display: none;\n  }\n\n  .viewCategories:hover span {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
